'use client';

import { ReactElement } from 'react';
import { Box, Stack, Typography } from '@mui/material';
import WhyWallfundItem from '@/components/item/WhyWallfundItem';
import { IconSvg } from '@/components/Icon';
import Container from '@/components/layout/Container';
import Section from '@/components/Section';
export interface WhyWallfundProps {
  icon: ReactElement;
  title: string;
  description: string;
  width: string;
}
const texts = {
  title: 'چرا در زیما سرمایه‌گذاری کنیم؟'
};
const items: WhyWallfundProps[] = [{
  icon: <IconSvg component='ClearInvest' />,
  title: 'سرمایه‌گذاری شفاف و مطمئن',
  description: 'با نظارت فرابورس ایران و کارگزاری بانک صادرات، تمامی طرح‌ها به صورت دقیق بررسی می‌شوند تا امکان سرمایه‌گذاری در پروژه‌ها با اطمینان کامل فراهم شود.  ',
  width: 'calc(50% - var(--spacing_xs))'
}, {
  icon: <IconSvg component='SocialProfitEffect' />,
  title: 'سودآوری همراه با اثرگذاری اجتماعی',
  description: 'سرمایه‌گذاری شما نه تنها سودآور است، بلکه به اشتغال‌زایی، رشد اقتصادی و ساخت آینده‌ای روشن‌تر برای ایران اختصاص می‌یابد.',
  width: 'calc(50% - var(--spacing_xs))'
}, {
  icon: <IconSvg component='LowRisk' />,
  title: 'ریسک کم و مدیریت‌شده',
  description: 'ارزیابی و اعتبارسنجی شفاف، ریسک سرمایه‌گذاری را به حداقل می‌رساند و فرصت‌هایی ایمن و پرسود ایجاد می‌کند.',
  width: 'calc(33% - var(--spacing_xs_nudge))'
}, {
  icon: <IconSvg component='NewIdea' />,
  title: 'حمایت از کارآفرینان و ایده‌های نو',
  description: 'سرمایه‌گذاری‌ شما از ایده‌های نوآورانه و کسب‌وکارهای کوچک و متوسط حمایت می‌کنند و نقشی کلیدی در ساختن آینده‌ای پایدار برای اقتصاد ایران دارند. ',
  width: 'calc(33% - var(--spacing_xs_nudge))'
}, {
  icon: <IconSvg component='EasyAccess' />,
  title: 'فرآیند آسان و دسترسی همگانی',
  description: 'در زیما، امکان سرمایه‌گذاری به شکلی آسان و شفاف فراهم شده است؛ از سرمایه‌های خرد تا مبالغ کلان، همه می‌توانند در پروژه‌های سودآور مشارکت کنند.  ',
  width: 'calc(33% - var(--spacing_xs_nudge))'
}];
const WhyWallfund = (): JSX.Element => {
  return <Box style={{
    background: 'linear-gradient(180deg, #FFFFFF 0%, #E5F2FF 50%, #FFFFFF 100%)'
  }} data-sentry-element="Box" data-sentry-component="WhyWallfund" data-sentry-source-file="WhyWallfund.tsx">
      <Container data-sentry-element="Container" data-sentry-source-file="WhyWallfund.tsx">
        <Section data-sentry-element="Section" data-sentry-source-file="WhyWallfund.tsx">
          <Typography variant='titleStrong__Wallfund' textAlign='center' color='text.primary' component='h2' width='100%' data-sentry-element="Typography" data-sentry-source-file="WhyWallfund.tsx">
            {texts.title}
          </Typography>

          <Stack direction='row' justifyContent='space-between' flexWrap='wrap' gap='var(--spacing_m)' data-sentry-element="Stack" data-sentry-source-file="WhyWallfund.tsx">
            {items.map((item, index) => <WhyWallfundItem {...item} key={index} />)}
          </Stack>
        </Section>
      </Container>
    </Box>;
};
export default WhyWallfund;